import { useInstallerContext } from '../context/InstallerContext';
export const useShouldOpenNewWindow = () => {
  const {
    avoidPostInstallation,
    preInstallationData: {
      isExternalDashboard,
      isAdvancedOauthApp
    },
    version,
    shareUrlId
  } = useInstallerContext();
  const isDevVersion = version === 'dev';
  const hasShareUrl = Boolean(shareUrlId);
  const isShareTestAppFlow = isDevVersion && hasShareUrl;
  const stayInSameWindowFlows = avoidPostInstallation || isShareTestAppFlow;
  const nonAdvancedOauthAppWithNewWindow = !stayInSameWindowFlows && (isExternalDashboard || isDevVersion);
  return isAdvancedOauthApp || nonAdvancedOauthAppWithNewWindow;
};
//# sourceMappingURL=useShouldOpenNewWindow.js.map